import React from 'react';

const  GameLoteriaLoaader = () => {
    return (<div class="skeleton-wrapper">
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
        <div class="skeleton-card"></div>
    </div>)
}

export default GameLoteriaLoaader;